import CreateNewNoteModal from './CreateNewNoteModal.view';

export default CreateNewNoteModal;
